import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
export function EditCoupon() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  return <div className="space-y-4" data-id="element-496" data-mp="1e8k3be3urrga">
      <div className="flex items-center justify-between" data-id="element-497" data-mp="1a7hxufjcej5v">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-498" data-mp="1a91ggcsh16at">
          {isEdit ? 'Edit Coupon' : 'Add Coupon'}
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/coupons')} data-id="element-499" data-mp="15eovtzf9doxh">
          ← Back to Coupons
        </Button>
      </div>

      <Card data-id="element-500" data-mp="qiprmzv9s8xm">
        <CardContent className="pt-6" data-id="element-501" data-mp="qlbwgrqs0ac5">
          <form className="space-y-4 max-w-md" data-id="element-502" data-mp="mhnoi7y8fcqd">
            <div data-id="element-503" data-mp="mk0d33yhwlce">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-504" data-mp="3f646gipdqb3u">
                Coupon Code
              </label>
              <input type="text" defaultValue={isEdit ? 'AN270' : ''} className="h-8 w-full rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-505" data-mp="3jx3zvdzaib1l" />
            </div>
            <div data-id="element-506" data-mp="1rhaw70450ki">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-507" data-mp="1qy2pi09lqjo">
                Discount Type
              </label>
              <select defaultValue={isEdit ? 'Percentage' : 'Dollar Amount'} className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-508" data-mp="6pj3pjncce96">
                <option data-id="element-509" data-mp="2dg8sckkvvd3l">Dollar Amount</option>
                <option data-id="element-510" data-mp="2dfgxjbz41jed">Percentage</option>
              </select>
            </div>
            <div data-id="element-511" data-mp="2hj53xrc0a8y1">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-512" data-mp="2hjoolft1jbfr">
                Usage Type
              </label>
              <select defaultValue={isEdit ? 'Unlimited by Customer' : 'Per Customer'} className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-513" data-mp="j0jryq5n4u8j">
                <option data-id="element-514" data-mp="9agsq87xek1r">Per Customer</option>
                <option data-id="element-515" data-mp="59oh58bl032b">General Use</option>
                <option data-id="element-516" data-mp="5aq3i8y1sbzc">Unlimited</option>
                <option data-id="element-517" data-mp="a2717r1v2xq">Unlimited by Customer</option>
              </select>
            </div>
            <div data-id="element-518" data-mp="3rgdbldv9qltt">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-519" data-mp="3rftqxpe8hjc3">
                Group
              </label>
              <select defaultValue="PAR" className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-520" data-mp="3mibs4rtxkkht">
                <option data-id="element-521" data-mp="1kqf96x5fo8d0">PAR</option>
                <option data-id="element-522" data-mp="1t6w924mza3eb">SAAR</option>
              </select>
            </div>
            <div data-id="element-523" data-mp="1t4tnbwsuywfe">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-524" data-mp="1x8hvohpbdw1p">
                Discount Amount
              </label>
              <input type="text" defaultValue={isEdit ? '100.00' : ''} className="h-8 w-32 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-525" data-mp="21yy8bzlb9dn0" />
            </div>
            <div data-id="element-526" data-mp="1e9dqxl4t2ofu">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-527" data-mp="1e8vlpz060zvs">
                Uses
              </label>
              <input type="text" defaultValue={isEdit ? '0' : ''} className="h-8 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-528" data-mp="1j75fc568rsfa" />
            </div>
            <div data-id="element-529" data-mp="2zm6wy3glz2t8">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-530" data-mp="2zloxyz2kaahm">
                Expire Date
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-531" data-mp="cgn5dpo8vg6g">
                <option data-id="element-532" data-mp="lga423pla7vt">Not Set</option>
                <option data-id="element-533" data-mp="ld4gwu0itg2q">Set</option>
              </select>
            </div>
            <div data-id="element-534" data-mp="geksmmygfs77">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-535" data-mp="gi8npqjjsmo1">
                Limitations
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-536" data-mp="qek0siqypgjj">
                <option data-id="element-537" data-mp="14572mjs0rmju">All Courses/Packages</option>
                <option data-id="element-538" data-mp="103lge7tlhvwz">Only Single Course</option>
                <option data-id="element-539" data-mp="104wup1ko2m2c">Specific Course</option>
                <option data-id="element-540" data-mp="1e3d0mqapg8jf">Specific Package</option>
              </select>
            </div>
            <div data-id="element-541" data-mp="1951r6gobo01q">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-542" data-mp="195kxt18iv20g">
                Exceed?
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-32" data-id="element-543" data-mp="1srwibyoufzq7">
                <option data-id="element-544" data-mp="1isnulnkknhca">No</option>
                <option data-id="element-545" data-mp="1irdvqw5wa54l">Yes</option>
              </select>
            </div>
            <div className="pt-2" data-id="element-546" data-mp="1nqz3nw31lntg">
              <Button type="submit" data-id="element-547" data-mp="1npxgit8r5avd">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}